import { Component } from '@angular/core';

import { Toast } from './class/toast';
import { ToastService } from './toast.service';

@Component({
  selector: 'uex-toast-wrapper',
  templateUrl: './wrapper.component.html',
  host: {
    'class': 'uex-toast-wrapper'
  }
})
export class ToastWrapperComponent {
  constructor(
    private _toastService: ToastService
  ) { }

  public get toasts(): Array<Toast> {
    return this._toastService.toasts;
  }
}
